import type { AnchorHTMLAttributes, ButtonHTMLAttributes, ReactNode } from "react";
import "./Button.css";
import { siteUrl } from "../../wordpress";

type Variant = "yellow" | "outline" | "ink";

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
	variant?: Variant;
	children: ReactNode;
};

/** Botão retangular em caixa alta, no espírito tipográfico do site. */
export function Button({
	variant = "outline",
	className,
	children,
	...rest
}: ButtonProps) {
	return (
		<button
			className={["btn", `btn--${variant}`, className].filter(Boolean).join(" ")}
			{...rest}
		>
			{children}
		</button>
	);
}

type LinkButtonProps = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "href"> & {
	href: string;
	variant?: Variant;
	children: ReactNode;
};

/** Mesma aparência do botão, semântica de link. */
export function LinkButton({
	href,
	variant = "yellow",
	className,
	children,
	...rest
}: LinkButtonProps) {
	return (
		<a
			href={siteUrl(href)}
			className={["btn", `btn--${variant}`, className]
				.filter(Boolean)
				.join(" ")}
			{...rest}
		>
			{children}
		</a>
	);
}
